import Vue from 'vue';
import i18n from '@/translations/i18n';

const eventBus = new Vue();

export const SHOW_MESSAGE = 'showMessage';
export const REMOVE_REQUEST_MESSAGES = 'removeRequestMessages';
export const REMOVE_MESSAGE = 'removeMessage';
export const REMOVE_ALL_MESSAGES = 'removeAllMessages';
export const OPEN_CONFIRM_DIALOG = 'openConfirmDialog';
export const CONFIRM_DIALOG_CONFIRMED = 'confirmDialogConfirmed';
export const CONFIRM_DIALOG_CANCELLED = 'confirmDialogCancelled';

// helper to open confirm dialog with less code
export const openConfirmDialog = (params) => {
  let title = i18n.t('common.confirmAction');
  if (typeof params === 'string') {
    title = params;
  } else if (params?.title) {
    title = params.title;
  }
  eventBus.$emit(OPEN_CONFIRM_DIALOG, {
    title,
  });
  return new Promise((resolve) => {
    eventBus.$on(CONFIRM_DIALOG_CONFIRMED, async () => {
      resolve(true);
      eventBus.$off(CONFIRM_DIALOG_CONFIRMED);
      eventBus.$off(CONFIRM_DIALOG_CANCELLED);
    });
    eventBus.$on(CONFIRM_DIALOG_CANCELLED, async () => {
      resolve(false);
      eventBus.$off(CONFIRM_DIALOG_CONFIRMED);
      eventBus.$off(CONFIRM_DIALOG_CANCELLED);
    });
  });
};

export default eventBus;
